import { AccordionEntry } from '@rsa-digital/evo-shared-components/components/Accordion';
import { graphql } from 'gatsby';
import React from 'react';
import {
  trackAccordionCollapseClick,
  trackAccordionExpandClick,
} from 'helpers/eventTracking';
import { StyledAccordion } from './styles';
import { Accordion as AccordionType } from './types';
import mapAccordionBlocks from '../../../helpers/blockMappers/mapAccordionBlocks';

type AccordionBlockProps = {
  accordion: AccordionType;
};

export const query = graphql`
  # add the top level Accordion block for a page template here, and add any flexible blocks inside that fragment in /fragments.ts
  fragment AccordionBlockTemplateAPage on cs__template_a_blocksaccordion {
    html_id
    initially_display_entries
    ...AccordionEntriesTemplateAAccordion
  }

  fragment AccordionBlockTemplateDPage on cs__template_d_blocksaccordion {
    html_id
    initially_display_entries
    ...AccordionEntriesTemplateDAccordion
  }

  fragment AccordionBlockTemplateEPage on cs__template_e_blocksaccordion {
    html_id
    initially_display_entries
    ...AccordionEntriesTemplateEAccordion
  }

  fragment AccordionBlockTemplateIPage on cs__template_i_blocksaccordion {
    html_id
    initially_display_entries
    ...AccordionEntriesTemplateIAccordion
  }

  fragment AccordionBlockTemplateJPage on cs__template_j_blocksaccordion {
    html_id
    initially_display_entries
    ...AccordionEntriesTemplateJAccordion
  }

  fragment AccordionBlockSegmentSelectorOption on cs__segment_selector_option_blocksaccordion {
    html_id
    initially_display_entries
    ...AccordionEntriesSectionSelectorOptionAccordion
  }

  fragment AccordionBottomBlockSegmentSelectorOption on cs__segment_selector_option_bottom_blocksaccordion {
    html_id
    initially_display_entries
    ...BottomAccordionEntriesSectionSelectorOptionAccordion
  }
`;

const AccordionBlock: React.FC<AccordionBlockProps> = ({ accordion }) => {
  const accordionEntries = accordion.accordion_entries.map(
    (entry): AccordionEntry => ({
      title: entry.accordion_entry.title,
      content: mapAccordionBlocks(entry.accordion_entry.content),
      onExpand: trackAccordionExpandClick(entry.accordion_entry.title),
      onCollapse: trackAccordionCollapseClick(entry.accordion_entry.title),
    })
  );

  return (
    <StyledAccordion
      id={accordion.html_id}
      className="accordion"
      data-cy="Accordion"
      accordionEntries={accordionEntries}
      initiallyDisplayEntries={accordion.initially_display_entries}
    />
  );
};

export default React.memo(AccordionBlock);
